import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    codeProp: 'umUserCode',
    mapIdProp: 'uiMapId',
    mapStsCodeProp: 'uiMapStsCode',
    mapTypeCode: 'UI_MAP',
    name: '系统入口',
    ownerIdProp: 'uaId',
    ownerTextProp: 'uaName',
    ownerType: 'UA',
    textProp: 'umName',
    type: 'UM',
}
